import styles from "../../style.module.scss";
import useStore from "../../store/store";
import {useEffect, useState} from "react";
import Hint from "../ui/hint/hint";
import {formatLocationPriceLabel, getLocationServicePrice, sortLocationServices} from "../../utils/location-service";
import {getServiceDescription, getServiceName} from "../../utils/service-text";

function Step4({number, services}) {
    const [open, setOpen] = useState(false);
    const ratesHide = useStore((state) => state.ratesHide)
    const carDeliveryLocation = useStore((state) => state.carDeliveryLocation)
    const setCarDeliveryLocation = useStore((state) => state.setCarDeliveryLocation)
    const startHours = useStore((state) => state.startHours)
    const workTime = useStore((state) => state.workTime)
    const lang = useStore((state) => state.lang)
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(window.innerWidth <= 991);
    }, []);

    const t = {
        carDeliveryLocation: lang === 'en' ? 'Car drop-off location' : 'Место подачи авто',
        inOffice: lang === 'en' ? 'In the office' : 'В офисе',
    };

    const getCurrentValue = () => {
        if (carDeliveryLocation) {
            const location = services.filter((service) => service.caraddonid === carDeliveryLocation);
            if (location && location[0]) {
                return getServiceName(location[0], lang);
            }
        }
        return t.inOffice;
    }
    if (!services) {
        return null;
    }

    const locationServices = sortLocationServices(services, isMobile);


    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
            <div className={styles.newOrder__stepNumber}>
                {ratesHide ? number - 1 : number}
            </div>
            {t.carDeliveryLocation}
            <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
            <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
        </div>
        {
            open && (
                <div className={styles.newOrder__stepContent}>
                    <div className={styles.locations}>
                        <div className={styles.location} onClick={() => setCarDeliveryLocation(null)}>
                            <div className={`${styles.checkbox} ${!carDeliveryLocation && styles.checked}`}/>
                            <span className='p-small-size'>{t.inOffice}</span>
                        </div>
                        {
                            locationServices.map((item) => {
                                if (item.caraddonsitegroup === 'Место подачи автомобиля') {
                                    const price = getLocationServicePrice(item, {
                                        isPickup: true,
                                        startHours,
                                        workTime,
                                    });
                                    if (price > 0) {
                                        const serviceDescription = getServiceDescription(item, lang);

                                        return (<div key={item.caraddonid} className={styles.location}
                                                     onClick={() => setCarDeliveryLocation(item.caraddonid)}>
                                            <div
                                                className={`${styles.checkbox} ${carDeliveryLocation === item.caraddonid && styles.checked}`}/>
                                            <span className={`${styles.heading} p-small-size`}>
                                            {getServiceName(item, lang)}
                                                {formatLocationPriceLabel(item, price, lang)}
                                                {
                                                    !!serviceDescription && (
                                                        <Hint text={serviceDescription}/>)
                                                }
                                        </span>
                                        </div>)
                                    }
                                }
                                return null;
                            })
                        }
                    </div>
                </div>
            )
        }

    </div>);
}

export default Step4;
